import { createContext } from 'react'

const StatsContext = createContext({
  statFlags: {}, 
  setStatFlags: () => {},
})

export default StatsContext